<template>
  <div class='container-fluid'>
    <b-row>
      <b-nav class="admin-sub-nav" pills>
        <b-nav-item v-for="team in teams" :key="team.mailbox.id" @click="getTeam(team.mailbox.id)" :class="isActive(team.mailbox.id)" action>
          {{ team.name }}
        </b-nav-item>
      </b-nav>
    </b-row>
    <b-row>
      <b-container v-if="team.id" fluid class="admin-sub-nav">
        <v-select v-model="savedReply" value="" :options="savedReplies"></v-select>
        <b-button @click="newReply = true; savedReply = null; reply = {}" variant="primary">Add New +</b-button>
      </b-container>
      <b-form v-if="reply" class="text-left" @submit.stop.prevent="handleSubmit">
        <b-form-input v-model="reply.name" type="text" placeholder="Name"></b-form-input>
        <quill-editor  style="height: 220px" v-model="reply.content" ref="replyEditor" :options="editorOption"></quill-editor>
        <b-button variant="warning" type="submit">Save</b-button>
        <b-button variant="danger" @click="handleDestroy">Delete</b-button>
        <h4 class="mt-4">Use {{subText}} to sub for customer full name.</h4>
      </b-form>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      savedReplies: [],
      savedReply: null,
      reply: null,
      newReply: false,
      team: {},
      active: '',
      editorOption: {
        modules: {
        }
      },
      subText: '{{customer}}'
    }
  },
  computed: {
    ...mapGetters([ 'teams' ])
  },
  methods: {
    isActive (name) {
      return this.active === name ? 'active' : 'inactive'
    },
    makeActive (name) {
      this.active = name
    },
    getTeam (team) {
      var t = this.teams.find(function (t) {
        return t.mailbox.id === team
      })
      this.team = t
      this.makeActive(team)
      this.savedReply = null
      this.newReply = false
      this.reply = null
      this.getReplies(team)
    },
    getReplies (team) {
      var vm = this
      this.$http.get('/mailboxes/' + team + '/saved_replies')
        .then(function (response) {
          vm.savedReplies = response.data.map(function (reply) {
            return { label: reply.name, value: reply.id, name: reply.name, content: reply.content }
          })
        })
        .catch(e => {
          console.log(e)
        })
    },
    handleSubmit () {
      var vm = this
      var replyObject = this.reply
      if (this.newReply) {
        this.$http.post('/mailboxes/' + vm.team.mailbox.id + '/saved_replies', {saved_reply: replyObject})
          .then(() => {
            this.getReplies(vm.team.mailbox.id)
            this.newReply = false
            this.reply = null
            this.savedReply = false
          })
          .catch(e => { console.log(e.response) })
      } else {
        this.$http.put(`/mailboxes/${vm.team.mailbox.id}/saved_replies/${vm.reply.value}`, {saved_reply: replyObject})
          .then(() => {
            this.getReplies(vm.team.mailbox.id)
            this.newReply = false
            this.reply = null
            this.savedReply = false
          })
          .catch(e => { console.log(e.response) })
      }
    },
    handleDestroy () {
      var del = confirm('Are you sure?')
      if (del === true) {
        var vm = this
        this.$http.delete(`/mailboxes/${vm.team.mailbox.id}/saved_replies/${vm.reply.value}`)
          .then(() => {
            this.getReplies(vm.team.mailbox.id)
            this.newReply = false
            this.reply = null
            this.savedReply = false
          })
          .catch(e => { console.log(e) })
      }
    }
  },
  watch: {
    savedReply: function () {
      if (this.savedReply) {
        this.newReply = false
        this.reply = this.savedReply
      }
    }
  }
}
</script>

<style scoped>
  .admin-sub-nav {
    display: inline-flex;
  }
  .custom-select {
    margin-right: 10px;
  }
  .v-select {
    margin-right: 10px;
    min-width: 50%;
  }
  li.nav-item.active, .nav-item.active a {
    color: #fff;
    background-color: #007bff;
    border-radius: .25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/SavedReplies.vue